import { useEffect, useRef } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const { setAuthedUser, API } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      window.history.replaceState({}, "", "/");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google-session`, { session_id: sessionId });
        setAuthedUser(res.data);
      } catch {
        setAuthedUser(false);
      } finally {
        window.history.replaceState({}, "", "/app");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-white"
      data-testid="auth-callback"
    >
      <p className="text-sm uppercase tracking-[0.2em] text-zinc-500">Signing you in…</p>
    </div>
  );
}
